<template>
  <div class="chat-player-list">
    <p class="title is-6">{{ title }}</p>
    <div v-if="loading" class="is-size-7">Загрузка…</div>
    <div v-else-if="players.length === 0" class="is-size-7 has-text-grey">
      Игроков нет
    </div>
    <ul v-else class="player-items">
      <li v-for="player in players" v-bind:key="player.id" class="player-item">
        <span class="player-name" v-bind:class="{ 'is-self': player.is_self }">
          @{{ player.username }}
          <span v-if="player.is_self" class="self-label">(вы)</span>
        </span>
        <span v-if="player.is_self" class="is-size-7 has-text-grey">—</span>
        <button
          v-else
          type="button"
          class="button is-small"
          v-bind:class="buttonClass(player)"
          v-bind:disabled="player.handshake_status === 'opened'"
          v-on:click="$emit('private-chat', player)"
        >
          {{ buttonLabel(player) }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Игроки в системе',
    },
    players: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    buttonLabel (player) {
      if (player.handshake_status === 'opened') return 'Открыт'
      if (player.handshake_status === 'pending') return 'Ожидание…'
      return 'Приватный чат'
    },
    buttonClass (player) {
      if (player.handshake_status === 'opened') return 'is-success is-light'
      if (player.handshake_status === 'pending') return 'is-warning is-light'
      return 'is-link is-light'
    },
  },
}
</script>

<style scoped>
.chat-player-list {
  width: 220px;
  min-width: 220px;
  border-left: 1px solid #ededed;
  padding-left: 0.75rem;
  overflow-y: auto;
}

.player-items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.player-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.player-name {
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.player-name.is-self {
  font-weight: 600;
}

.self-label {
  font-weight: 400;
  color: #7a7a7a;
}
</style>
